import type { Cache, ResolveInfo } from '@urql/exchange-graphcache';
import { TEAM_PEOPLE_CACHE_FIELDS } from '@/client/exchanges/cacheExchange/constants';
import invalidateFields from '@/client/exchanges/cacheExchange/invalidateFields';

export default function update_person_team(
  _parent: unknown,
  _args: unknown,
  cache: Cache,
  _info: ResolveInfo,
) {
  invalidateFields(TEAM_PEOPLE_CACHE_FIELDS, cache);
}
